import React from 'react';
import PhotoContainer from '../../PhotoContainer';

const ChangeRequestsView = ({
  changeRequests,
  renderChangeRequest,
  isHTML,
}) => {
  if (changeRequests && changeRequests.length) {
    return (
      <div className="answer">
        <hr />
        <span className="">Others requested the following changes:</span>
        {changeRequests.map((changeRequest, i) => (
          <div key={i} className="change-request">
            {changeRequest.users.map((user, i) => (
              <div className="user-photo" key={i}>
                <PhotoContainer
                  className="photo-container"
                  image={user ? user.avatar : ''}
                  defaultImg="user"
                />
              </div>
            ))}
            <div className="change-content">
              <span className="text-red">{changeRequest.userNames}</span>
              &nbsp;&nbsp;requested changes:&nbsp;&nbsp;
              {isHTML ? (
                <div
                  className="text-red"
                  dangerouslySetInnerHTML={{
                    __html: renderChangeRequest(changeRequest),
                  }}
                ></div>
              ) : (
                <span className="text-red">
                  {renderChangeRequest(changeRequest)}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    return null;
  }
};

ChangeRequestsView.defaultProps = {
  isHTML: false,
};

export default ChangeRequestsView;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/ChangeRequestsView.js